//main
export const AD_LIST_PAGE_ADS_LIMIT = 10;
export const AD_LIST_PAGE_BOOSTED_LIMIT = 2;
export const AD_LIST_PAGE_PREMIUM_LIMIT = 5;

export const SELLER_PROFILE_PAGE_ADS_LIMIT = 5;
export const SELLER_PROFILE_PAGE_BOOSTED_LIMIT = 2;
export const SELLER_PROFILE_PAGE_PREMIUM_LIMIT = 5;

export const AD_SETTINGS_PAGE_AD_LIMIT = 10;

//admin
export const ADMIN_PAGE_USERS_AD_LIMIT = 10;
export const ADMIN_PAGE_ADS_AD_LIMIT = 10;
export const ADMIN_PAGE_BOOST_AD_LIMIT = 10;
